const endorsementStatus = {
    INVALID : 0,

    DRAFT : 1,

    SUBMITTED : 2,

    PENDING_ISSUANCE : 3,

    ISSUED : 4,

    DECLINED : 5,

    APPROVED : 6,

    INVALID_RATING : 7,

    VALID_RATING : 8,

    APPROVED_INVALID_RATING : 9,

    APPROVED_VALID_RATING : 10,

    PRICED : 11,

    APPROVED_PRICED : 12

};

angular.module('gw-um-j2js')
    .constant('endorsementStatus', endorsementStatus);